import React, { useEffect } from "react";
import { ResultPaginationLoadMoreProps } from "@usereactify/search";

export type ExampleResultPaginationLoadMoreProps = React.ComponentProps<
  NonNullable<ResultPaginationLoadMoreProps["render"]>
> & {
  handle?: string;
};

export const ResultPaginationLoadMore: React.FC<ExampleResultPaginationLoadMoreProps> = (props) => {
  const percent = (100 * props.resultStats.displayedResults) / props?.resultStats?.numberOfResults!;

  useEffect(() => {
    if (window !== undefined) {
      const clickedTime = new Date().getTime();
      localStorage.setItem(
        "salt-and-pepper:lastPageSize",
        JSON.stringify({
          size: props.resultStats?.displayedResults <= 12 ? 12 : props.resultStats?.displayedResults,
          collection: props?.handle || 'search',
          clickedTime,
        })
      );
    }
  }, [props.resultStats?.displayedResults, props.handle]);

  return (
    <div className="pagination-wrapper">
      <p>{`Showing ${props.resultStats.displayedResults} of ${props.resultStats.numberOfResults}`}</p>
      <div className="load-more-bar-full">
        <div style={{ width: `${percent}%` }} className="load-more-bar"></div>
      </div>
      <button
        className="rs__pagination__loadmore-button button secondary"
        onClick={() => props.handleLoadMore()}
        disabled={!props.hasMore}
      >
        {"Load more products"}
      </button>
    </div>
  );
};
